<section class="section-padding-home home-divider-light bg-slate-50">
  <div class="container-max">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <span class="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-4">
        Why Choose Us
      </span>
      <h2 class="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
        Why Velora Infra Stands Out
      </h2>
      <p class="text-xl text-slate-600 max-w-2xl mx-auto">
        With years of proven expertise and a commitment to excellence, we're your trusted partner for world-class
        construction.
      </p>
    </div>

    <!-- Reasons Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div *ngFor="let reason of reasons; let i = index"
        class="group p-8 bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-2xl hover:border-primary-500 hover:shadow-2xl transition-all duration-300"
        [style.animation]="'fadeInUp ' + (0.4 + i * 0.08) + 's ease-out'">
        <!-- Icon -->
        <div
          class="w-16 h-16 mb-6 rounded-xl bg-gradient-to-br from-primary-100 to-accent-100 group-hover:from-primary-500 group-hover:to-accent-500 flex items-center justify-center transition-all duration-300 flex-shrink-0">
          <svg class="w-8 h-8 text-primary-600 group-hover:text-white transition-colors" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <!-- Award Icon -->
            <path *ngIf="reason.icon === 'award'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            <!-- Users Icon -->
            <g *ngIf="reason.icon === 'users'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </g>
            <!-- Shield Icon -->
            <g *ngIf="reason.icon === 'shield'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <path d="m9 12 2 2 4-4"></path>
            </g>
            <!-- Clock Icon -->
            <path *ngIf="reason.icon === 'clock'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            <!-- Sliders Icon -->
            <path *ngIf="reason.icon === 'sliders'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 6h4m4 0h8M4 12h10m4 0h2M4 18h6m4 0h8M8 4v4M14 10v4M10 16v4"></path>
            <!-- Trending Up Icon -->
            <path *ngIf="reason.icon === 'trending-up'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
          </svg>
        </div>

        <!-- Content -->
        <h3 class="text-2xl font-bold text-slate-900 mb-3 group-hover:text-primary-600 transition-colors">
          {{ reason.title }}
        </h3>
        <p class="text-slate-600 mb-6 leading-relaxed">{{ reason.description }}</p>

        <!-- Features -->
        <div class="space-y-2">
          <div *ngFor="let feature of reason.features" class="flex items-center gap-2 text-slate-700 text-sm">
            <svg class="w-4 h-4 text-primary-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd" />
            </svg>
            {{ feature }}
          </div>
        </div>
      </div>
    </div>

    <!-- Call to Action -->
    <div class="mt-16 text-center">
      <p class="text-lg text-slate-600 mb-6">
        Ready to work with the best?
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a routerLink="/contact"
          class="px-8 py-4 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-bold rounded-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2">
          Start Your Project
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
</section>